module.exports = __webpack_public_path__ + "static/media/rasapi32_101.41d889b6.ico";